export type PlanTableAccessMode = 'ALL' | 'SELECTED';
/** READ | READ_WRITE: the same vocabulary the Data Service itself uses, so a plan's grant
 *  lands on a configuration row without translation and is capped by the connection. */
export type PlanAccessPermission = 'READ' | 'READ_WRITE';

export interface subscriptionPlanAdminRequest {
  name: string;
  /** Form state holds text; the payload sends a number. Never send "" - it binds to null. */
  price: string | number;
  trialDays: number;
  couponCode: string;
  discountAmount: number;
  discountPercent: number;
  active: boolean;
  isVisibleOnUI: boolean;
  isTrail: boolean;
  credits: number;
  amount: number;
  features: string[];
  orderBy: number;
  isAddon: boolean;
  isDataService: boolean;

  /**
   * What a purchase of this plan grants, used only when isDataService is true.
   * Sent with every save; the backend clears them when the plan is not a Data
   * Service plan, so unticking the flag cannot leave a stale connection behind.
   */
  dataServiceConnectionId?: string | null;
  dataServiceAllowQueryBuilder?: boolean;
  dataServiceAllowConsole?: boolean;
  dataServiceTableAccessMode?: PlanTableAccessMode;
  dataServiceTables?: string[];
  dataServicePermission?: PlanAccessPermission;
}


export interface subscriptionPlanAdminResponse {
  id: string;                   // UUID
  name: string;
  /** The API returns a number; the form binds it as text, so both are accepted. */
  price: string | number;
  trialDays: number;
  couponCode: string;
  discountAmount: number;
  discountPercent: number;
  active: boolean;
  isVisibleOnUI: boolean;
  isTrail: boolean;
  credits: number;
  amount: number;
  features: string[];
  createdAt: string;
  updatedAt: string;
  isAddon?: boolean;
  isDataService?: boolean;
  dataServiceConnectionId?: string | null;
  dataServiceAllowQueryBuilder?: boolean;
  dataServiceAllowConsole?: boolean;
  dataServiceTableAccessMode?: PlanTableAccessMode;
  dataServiceTables?: string[];
  dataServicePermission?: PlanAccessPermission;
}


export const initialSubscriptionPlanAmdinRequest: subscriptionPlanAdminRequest = {
  name: "",
  price: "",
  trialDays: 0,
  couponCode: "",
  discountAmount: 0,
  discountPercent: 0,
  active: true,
  isVisibleOnUI: true,
  isTrail: false,
  credits: 0,
  amount: 0,
  features: [],
  orderBy: 0,
  isAddon: false,
  isDataService: false,
  dataServiceConnectionId: '',
  dataServiceAllowQueryBuilder: true,
  dataServiceAllowConsole: false,
  dataServiceTableAccessMode: 'ALL',
  dataServiceTables: [],
  dataServicePermission: 'READ',
};